export default __webpack_public_path__ + "static/media/guide03@2x.595b69dc.png";